import React, {Component} from 'react';
import {  Link } from 'react-router-dom'; 
  
import { base_url} from '../common/Constants';
 


 
class PageHeader extends React.Component{
 
    render()
    { 

        const banners = JSON.parse(localStorage.getItem("page_banners"));
        var bann = this.props.banner ? this.props.banner : base_url+'assets/_nuxt/img/portals.e3cfe93.jpg';
        var banner = banners[this.props.title] ? banners[this.props.title].image : bann;
         
        return (  <div
          data-aos="fade-in"
          data-aos-duration="1000"
          className="page-header aos-init aos-animate"
          style={{ height: "600px" }}
        >
          <img
            src={banner}
            alt="Who we are banner"
          />
          <div className="header-filter" />

          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            className="page-headline aos-init aos-animate"
          >
            { this.props.main_title == "News & Updates" && 
             <div data-v-8e945784="" class="page-date"><div data-v-8e945784="" class="bs-month">
          {this.props.blog.created_month}
        </div> <div data-v-8e945784="" class="bs-day">
          {this.props.blog.created_date}
        </div></div>
    }
     { this.props.main_title != "News & Updates" && 
            <div className="page-breadcumbs">
              <div className="crumbs" data-v-7176568e="">
                <div className="crumb">
                  <a href="/" className="nuxt-link-active">
                    HOME
                  </a>
                </div>

                <div className="crumb">
                  <a href="/" className="nuxt-link-active">
                    <span className="crumb-slash">/</span>
                    {this.props.main_title  || "explore"}
                  </a>
                </div>

                <div className="crumb">
                  <a href="/" className="nuxt-link-active">
                    <span className="crumb-slash">/</span>
                   {this.props.page}
                  </a>
                </div>

                <div className="crumb">
                  {/* empty crumb placeholder */}
                </div>
              </div>
            </div>
    }
            <div className="page-heading">
                { this.props.main_title == "News & Updates" && 
                      <Link data-v-8e945784="" to={base_url+`news`} class="page-breadcumbs nuxt-link-active">MEDIA / NEWS &amp; UPDATES</Link>
                }
              <b>{this.props.title}</b>
            </div>
          </div>
        </div>
      
        );
     
}

}

export default PageHeader;